// Add-to-cart for one-click upsell buttons ([data-upsell-add], e.g. "Combine com" on the PDP).
// Delegated on document so it survives any re-render of the buttons' container.
(function () {
  if (window.__upsellAddBound) return;
  window.__upsellAddBound = true;

  const addVariant = (button) => {
    const variantId = button.dataset.variantId;
    if (!variantId || button.classList.contains('loading')) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    button.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Upsell add to cart error:', response.description || response.message);
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-add', productVariantId: variantId });
        if (cart) cart.renderContents(response);
      })
      .catch((error) => console.error('Upsell add to cart error:', error))
      .finally(() => button.classList.remove('loading'));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-upsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    addVariant(button);
  });
})();
